/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { ChevronLeft, ChevronRight } from 'lucide-react';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../components/ui/button.js';

interface WeekNavProps {
  readonly rangeLabel: string;
  readonly onPrev: () => void;
  readonly onThisWeek: () => void;
  readonly onNext: () => void;
}

/** Prev / This week / Next controls with the visible date range (Figma "Schedule"). */
export function WeekNav({ rangeLabel, onPrev, onThisWeek, onNext }: WeekNavProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="mb-4 flex items-center gap-2">
      <Button
        size="sm"
        variant="outline"
        onClick={onPrev}
        aria-label={t('therapist.schedule.prevWeek')}
      >
        <ChevronLeft className="h-4 w-4" aria-hidden="true" />
      </Button>
      <Button size="sm" variant="outline" onClick={onThisWeek}>
        {t('therapist.schedule.thisWeek')}
      </Button>
      <Button
        size="sm"
        variant="outline"
        onClick={onNext}
        aria-label={t('therapist.schedule.nextWeek')}
      >
        <ChevronRight className="h-4 w-4" aria-hidden="true" />
      </Button>
      <span className="ml-2 text-sm font-medium text-slate-600 dark:text-slate-300">
        {rangeLabel}
      </span>
    </div>
  );
}
